const paths = {
  aviso: "/aviso",

  relatorio: "/relatorios",

  bancoImagem: "/bancoimagem",
  bancoImagemCategoria: "/bancoimagemcategoria",

  bannerLogin: "/bannerlogin",

  usuario: "/usuario",
  usuarioTipo: "/usuariotipo",
  usuarioMeusDados: "/meusdados",

  regional: "/regional",
  regionalVerba: "/regional-verba",
  regionalAprovador: "/regional-aprovador",
  regionalAprovadorTrade: "/regional-aprovador-trade",
  
  canal: "/canal",
  loja: "/loja",
  materialcomunicacao: "/materialcomunicacao",
  materialcomunicacaoTipo: "/materialcomunicacaotipo",
  fornecedor: "/fornecedor",

  unidade: "/unidade",

  chamadotipo: "/chamadotipo",

  pedidotipo: "/pedidotipo",

  perguntafrequente: "/perguntafrequente",

  produto: "/produto",
  marca: "/marca",
  produtoCategoria: "/produtocategoria",
  produtoSubCategoria: "/produtosubcategoria",

  produtoatividade: "/produtoatividade",
  
  fluxo: "/fluxo",

  formaPagamento: "/formapagamento",

  motivoAcao: "/motivoacao",

  onoffrede: "/onoffrede",

  onoffmaterialcomunicacao: "/onoffmaterialcomunicacao",

  acaoPromocionalCategoria: "/acaoPromocionalCategoria",
  acaoPromocionalCampoTipo: "/acaoPromocionalCampoTipo",    
  acaoPromocionalCampo: "/acaoPromocionalCampo",  
  acaoPromocional: "/acaoPromocional",

  ativacaoScanntech: "/ativacaoScanntech",
  ativacaoScanntechMarca: "/ativacaoScanntechMarca",

  extratos: "/extrato",
  extratoUsuarios: "/extrato/usuarios",
  extratoLojas: "/extrato/lojas",
  extratoProdutos: "/extrato/produtos",

  valorDiagramacao: "/valordiagramacao",
  valorFrete: "/valorfrete",
  valorProducao: "/valorproducao",

  layoutArte: "/layoutarte",
  layoutArteAcao: "/layoutarte/acao",
  layoutArteMateriais: "/layoutarte/materiais",
  layoutArteArtesFacil: "/layoutarte/artes-facil",
  
  campanha: "/campanha",
  rede: "/rede",
  solicitacao: "/solicitacao",

  etapalabel: "/etapalabel",

  solicitacaoAlterar: "/solicitacao/alterar",
  solicitacaoAlterarDados: "/solicitacao/alterar-dados",
  solicitacaoAlterarEntrega: "/solicitacao/alterar-entrega",
  solicitacaoAlterarProdutos: "/solicitacao/alterar-produtos",
  solicitacaoVoltarEtapa: "/solicitacao/voltar-etapa",

  solicitacaoValores: "/solicitacao/valores",
  solicitacaoPendencias: "/alterar-pendencia",
}

export default paths;